import React from 'react';
import { useOutlet } from 'react-router';
import NavbarVertical from './NavbarVertical';
import HeaderDefault from './HeaderDefault';
import Section from '../../components/Section';
import { Container } from 'react-bootstrap';
import DashboardMenu from '../../routes/DashboardRoutes';
import { useAuth } from '../../redux/ducks/auth';

const AdminLayout = ({ children, className, overflowHidden }) => {
	//#region useAuth

	const { authContext } = useAuth();

	//#endregion

	const outlet = useOutlet();

	const [showMenu, setShowMenu] = React.useState(true);

	const ToggleMenu = () => {
		return setShowMenu(!showMenu);
	};

	return (
		<div id="db-wrapper" className={`${overflowHidden ? 'chat-layout' : ''} ${showMenu ? '' : 'toggled'}`}>
			<div className="navbar-vertical navbar">
				<NavbarVertical
					menuOptions={DashboardMenu(authContext)}
					showMenu={showMenu}
					onClick={(value) => setShowMenu(value)}
				/>
			</div>
			<Section id="page-content" className="bg-ready-white p-0">
				<div className="header">
					<HeaderDefault data={{ title: <span>Admin Dashboard</span>, showSearch: false, showMenu: showMenu, SidebarToggleMenu: ToggleMenu }} />
				</div>
				<Container fluid className={(className ? className : 'p-4')}>
					{children}
					{outlet}
				</Container>
			</Section>
		</div>
	);
};
export default AdminLayout;
